import { ProductItemCombinedProps } from './types';

const usePresenter = (props: ProductItemCombinedProps): ProductItemCombinedProps => {
  return props;
};

export default usePresenter;
